import { render, staticRenderFns } from "./PrintPkgTicket.vue?vue&type=template&id=4a50b716&scoped=true&"
import script from "./PrintPkgTicket.vue?vue&type=script&lang=js&"
export * from "./PrintPkgTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50b716",
  null
  
)

export default component.exports